<div class="font-bold mb-3" i18n>ISM stores the credentials required to access your IMS network.</div>
<div class="font-bold mb-3" i18n>Please enter the Home Network Domain Name.</div>
<div class="ml-6 mb-3">
  @if (errorFound) {
    <rs-error-message class="mb-3" [message]="errorMessage" />
  }
  <div class="pt-3 pb-3">
    <input
      type="text"
      pInputText
      [(ngModel)]="profileValues.isimConfiguration.homeNetworkDomainName"
      (input)="handleFormEvents()"
      [maxlength]="maxLength"
    />
  </div>
</div>
<div class="font-bold mb-3" i18n>
  IMPI (IMS Private User Identity) & IMPU (IMS Public User Identity) are unique subscriber identifiers in the IMS network. IMPI is
  equivalent to IMSI and IMPU to MSISDN. Therefore, IMPI and IMPU will be set up for data generation.
</div>
<div class="ml-6 mb-3">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>Does your input file contain IMPI and IMPU?</span>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="isimConfiguration.inputFileContainsIMPIandIMPU"
          inputId="isimConfiguration.inputFileContainsIMPIandIMPU#1"
          value="1"
          [(ngModel)]="profileValues.isimConfiguration.inputFileContainsIMPIandIMPU"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="isimConfiguration.inputFileContainsIMPIandIMPU#1" i18n>Yes</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="isimConfiguration.inputFileContainsIMPIandIMPU"
          inputId="isimConfiguration.inputFileContainsIMPIandIMPU#0"
          value="0"
          [(ngModel)]="profileValues.isimConfiguration.inputFileContainsIMPIandIMPU"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="isimConfiguration.inputFileContainsIMPIandIMPU#0" i18n>No</label>
      </td>
    </tr>
  </table>
</div>
@if (
  +profileValues.isimConfiguration.inputFileContainsIMPIandIMPU === 0 &&
  profileValues.isimConfiguration.inputFileContainsIMPIandIMPU !== null
) {
  <div class="mb-3">
    <div class="font-bold" i18n>We will generate IMPI and IMPU in the following format.</div>
    <div>
      <ul>
        <li i18n>IMPI: 'IMSI'&#64;DOMAIN</li>
        <li i18n>IMPU: sip:'IMSI'&#64;DOMAIN</li>
      </ul>
    </div>
    <div class="font-italic" i18n>* If you require a unique format, please contact RiPSIM Professional Service.</div>
  </div>
}
